import { Message } from "./types";

import { useCentrifugeChannel } from "@/components/Centrifuge/useCentrifugeChannel";

const useChannel = (
  topic: string,
  event: string,
  callback: (message: Message) => void,
  enabled = true,
) => useCentrifugeChannel(topic, event, callback, enabled);

export { useChannel };
